import { User } from "../user/user.model";
import { BaseRate } from "./rate-base.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { Carrier } from "../carrier/carrier.model";
import { ContainerName } from "../shared/container/container-name.type.const";
import { ContainerPrices } from "../shared/container/container-prices.model";
import { Location } from "../location/location.model";
import { RateFclFlatRoute } from "./rate-flat-route-list/rate-fcl-flat-route.model";
import { FclPickupDeliveryRate } from "./rate-fcl-pickup-delivery.model";

export class FclFlatRate extends BaseRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected containerMargins: ContainerPrices = new ContainerPrices([]),
    protected equipment: ContainerName[] = [],
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected contractNumber?: string,
    protected availableOnline?: boolean,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    protected incoterms: string[] = [],
    protected pickupDeliveryRate?: FclPickupDeliveryRate,
    protected flatRateRoutes?: RateFclFlatRoute[],
    protected totals: ContainerPrices = new ContainerPrices([]),
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getContainerMargins(): ContainerPrices {
    return this.containerMargins;
  }

  public getEquipment(): ContainerName[] {
    return this.equipment;
  }

  public setEquipment(param: ContainerName[]) {
    this.equipment = param;
  }

  public getCurrency() {
    return this.currency;
  }

  public getFlatRateRoutes() {
    return this.flatRateRoutes;
  }

  public getAvailableOnline() {
    return this.availableOnline;
  }

  public setAvailableOnline(availableOnline) {
    this.availableOnline = availableOnline;
  }

  public setFlatRateRoutes(flatRateRoutes): void {
    this.flatRateRoutes = flatRateRoutes;
  }

  /** Table methods */
  public get realOriginLocation(): Location {
    return this.flatRateRoutes.length
      ? this.flatRateRoutes[0].originLocation
      : null;
  }

  public get realDestinationLocation(): Location {
    return this.flatRateRoutes.length
      ? this.flatRateRoutes[0].destinationLocation
      : null;
  }

  public get currency(): string {
    return this.flatRateRoutes.length ? this.flatRateRoutes[0].currency : null;
  }

  public getTotals(): ContainerPrices {
    return this.totals;
  }

  public getPickupDeliveryRate() {
    return this.pickupDeliveryRate;
  }

  public setPickupDeliveryRate(rate) {
    this.pickupDeliveryRate = rate;
  }

  public getIncoterms(): string[] {
    return this.incoterms;
  }

  public setIncoterms(incoterms: string[]): void {
    this.incoterms = incoterms;
  }

  public isValid(): boolean {
    return (
      !!this.name &&
      !!this.carrier &&
      !!this.validity &&
      !!this.equipment &&
      this.equipment.length > 0
    );
  }
}
